<template>
  <span class="ui-avatar" :class="[tone !== 'accent' && `ui-avatar--${tone}`, size !== 'md' && `ui-avatar--${size}`, big && 'ui-avatar--big']" aria-hidden="true">{{ text }}</span>
</template>

<script>
/** Krug sa inicijalima. tone: accent (narandžast) | neutral (siv) | blue; size: sm (26) | md (34) | lg (40); big (48) za zaglavlje panela. */
export default {
  name: "UiAvatar",
  props: {
    text: { type: String, default: "" },
    tone: { type: String, default: "accent" },
    size: { type: String, default: "md" },
    big: { type: Boolean, default: false },
  },
};
</script>
